/**
 * Basic configuration for qubit harvesting system
 */

// Qubit range configuration
export const qubitRange = {
  min: 20,
  max: 1000
};

// Metric weights for zone calculation
export const metricWeights = {
  coherence: 0.3,    // 30% weight
  entanglement: 0.3, // 30% weight
  resonance: 0.2,    // 20% weight
  particle: 0.1,     // 10% weight
  cosmic: 0.1        // 10% weight
};

// Quantum interference patterns
export const interferencePatterns = {
  constructive: [0.2, 0.35, 0.5, 0.7, 0.85, 1.0],
  destructive: [1.0, 0.85, 0.7, 0.5, 0.35, 0.2],
  neutral: [0.5, 0.6, 0.7, 0.7, 0.6, 0.5]
};

// Base multiplier caps
export const multiplierCaps = {
  quality: 1.5,     // Maximum 50% bonus from quality
  quantum: 1.5,     // Maximum 50% bonus from quantum state
  rarity: 1.5,      // Maximum 50% bonus from rarity
  particle: 1.5,    // Maximum 50% bonus from particles
  cosmic: 1.5,      // Maximum 50% bonus from cosmic events
  total: 5.0        // Maximum total multiplier
};

// Zone thresholds for distribution
export const zoneThresholds = [0.2, 0.4, 0.6, 0.8, 1.0];